import type { Instance, InstanceSize, TierConfig } from '@nx/state';

import type { InstanceConfigureFormData } from './form-data';

export const validate = (data: InstanceConfigureFormData, initialSize?: InstanceSize) => {
  if (!data.size) {
    return false;
  }

  const sizeChanged = data.size.sizeId !== initialSize?.sizeId;
  if (sizeChanged) {
    return data.confirmed || data.size.isTrial;
  }
  return true;
};

export const constructConfigureTierConfig = (tierConfig: TierConfig, instance: Instance): TierConfig => {
  const regions = (tierConfig.cloudProviderRegions[instance.cloudProvider] ?? []).filter(
    (s) => s.name === instance.region,
  );
  const config: TierConfig = {
    ...tierConfig,
    cloudProviderRegions: { [instance.cloudProvider]: regions },
  };
  return config;
};
